import React, {useCallback, useMemo, useState} from "react";
import ReactCreditCards from "../../../../custom/react-credit-cards";
import {formatMoney} from "../../../../../core/services/utils/utils";
import Button from "../../../base/button/button";
import {CustomerGiftCardTypeIds} from "../../../../../core/constants/enums";
import classnames from "classnames";
import {routeFunctions} from "../../../../../core/models/static/routes/app-routes";
import {ReactComponent as Chevron} from "../../../../../assets/images/chevron/chevron-down.svg";
import {ReactComponent as SeparatorLine} from "../../../../../assets/images/card-more-option-separator.svg";
import DateUtils from "../../../../../core/services/date-utils";
import useAccessLevels from "../../../../hooks/use-access-levels";
import {Link} from "react-router-dom";
import Collapse from "@mui/material/Collapse";

const GiftCard = ({
                      withWrapper,
                      remove,
                      buttonText = 'Refill',
                      buttonDisabled = false,
                      onButtonPressed,
                      card,
                      customerId,
                  }) => {
    const operatorAccessLevels = useAccessLevels();
    const [isExtended, setIsExtended] = useState(false);

    const issuer = useMemo(() => {
        switch (card?.type?.id) {
            case CustomerGiftCardTypeIds.refillable:
                return 'gift-card';
            default:
                return 'coupon';
        }
    }, [card?.type?.id]);

    /**
     * Gets users confirmation before removing the current entity.
     */
    const getRemoveConfirmation = useCallback(() => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Do you want to remove the selected gift card?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && remove().then(),
        );
    }, [remove]);

    return (
        <div
            className={classnames('position-relative card-with-mask', {
                'card-wrapper': withWrapper,
                "has-background-image": !!card?.fileName
            })}
            style={{'--background-image-url': `url(${card?.fileName})` ?? ''}}
        >
            <ReactCreditCards
                preview
                cvc={'***'}
                expiry={`${card?.expireDate ? DateUtils.serverToLocal(card?.expireDate).format('MM/YY') : '**/**'}`}
                focused={'name'}
                name={`${formatMoney(card.currentBalance ?? 0.0)}`}
                number={card?.cardNumber}
                issuer={issuer}
            />
            {
                typeof onButtonPressed === 'function' && !withWrapper &&
                <Button
                    size={'medium'}
                    variant={'outlined'}
                    color={'primary'}
                    className={'w-100 mt-2'}
                    onClick={() => onButtonPressed(card)}
                    disabled={buttonDisabled}
                >
                    {buttonText}
                </Button>
            }
            {
                withWrapper &&
                <>
                    <div className={'options-section'}>
                        {
                            (card?.type?.id === CustomerGiftCardTypeIds.refillable && typeof onButtonPressed === 'function')
                                ? <Button
                                    className='py-1'
                                    variant={'outlined'}
                                    color={'primary'}
                                    onClick={() => onButtonPressed(card)}
                                >
                                    {buttonText}
                                </Button>
                                : <div/>
                        }
                        <div
                            className={classnames('card-more-options', {'extended': isExtended})}
                            onClick={() => setIsExtended(prevState => !prevState)}
                        >
                            <p>More Options</p>
                            <Chevron className={'mt-1'}/>
                        </div>
                    </div>
                    <Collapse in={isExtended}>
                        <div className={'expanded-section-separator'}>
                            <SeparatorLine/>
                        </div>
                        {
                            customerId &&
                            operatorAccessLevels.packages.sales.paymentMethodsTransactionHistory &&
                            <Button
                                className='py-2 w-100 my-2'
                                variant={'outlined'}
                                color={'primary'}
                                component={Link}
                                to={routeFunctions.customer.cardSummary.giftCards(customerId, card.id)}
                            >
                                View Summary
                            </Button>
                        }
                        {
                            (typeof remove === "function") &&
                            <Button
                                className='p-2 w-100 mb-1'
                                variant={'outlined'}
                                color={'primary'}
                                onClick={getRemoveConfirmation}
                            >
                                Remove
                            </Button>
                        }
                    </Collapse>
                </>
            }
        </div>
    );
}

export default GiftCard;
